import OneTimePaymentTypes from '@common/constants/oneTimePaymentTypes';

const MoveInCostsTypes = {
  [OneTimePaymentTypes.DEPOSIT]: 'Security deposit',
  [OneTimePaymentTypes.PRORATED_RENT]: 'Prorated rent',
  [OneTimePaymentTypes.OTHER]: 'Other',
};

export default MoveInCostsTypes;
